import { Icons } from "../../utils/icons.jsx";
import Modal from "./Modal.jsx";

/**
 * Unified Delete Confirmation Modal Component
 * Handles different item types with consistent UI using common Modal
 */
function DeleteConfirmationModal({
  isOpen,
  onClose,
  onDelete,
  itemType = "user",
  itemName,
}) {
  const titles = {
    user: "ce cavalier",
    event: itemName ? `l’événement "${itemName}"` : "cet événement",
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title={
        <div className="modal-title">
          <Icons.Warning />
          Supprimer {titles[itemType]}
        </div>
      }
      footer={null}
    >
      <p className="modal-body">
        Souhaitez-vous <strong> supprimer définitivement</strong> ?
      </p>

      <button className="btn btn-danger" onClick={onDelete}>
        Supprimer
      </button>

      <button className="btn btn-cancel" onClick={onClose}>
        Annuler
      </button>
    </Modal>
  );
}
export default DeleteConfirmationModal;
